import type { QueryClient } from '@tanstack/react-query';
import api from '../../services/api';

/** entity: traffic-source, flow, rule-group, network, offer or landing-page. Traffic sources' PATCH is admin-only. */
export function canEditNotes(entity: string | undefined, role: string | undefined): boolean {
  if (!entity) return false;
  if (role === 'admin') return true;
  return role === 'media_buyer' && entity !== 'traffic-source';
}

export async function saveNotes(entity: string, id: string, notes: string | null): Promise<void> {
  await api.patch(`/${entity}s/${id}`, { notes });
}

const LIST_KEYS: Record<string, string> = {
  'traffic-source': 'traffic-sources', flow: 'flows', 'rule-group': 'rule-groups-library',
  network: 'networks', offer: 'offers', 'landing-page': 'landing-pages',
};

/**
 * Once a note is saved, every cached view of it is stale: the entity lists, its edit form (keyed by the entity
 * name), the report and its history. A form opened on its old copy would otherwise save the old note back.
 */
export function markNotesStale(qc: QueryClient, entity: string, { report = true } = {}): void {
  const keys = [[entity], [LIST_KEYS[entity]], ['notes-history'], ...(report ? [['tracking-stats'], ['tracking-drilldown']] : [])];
  for (const key of keys) {
    void qc.invalidateQueries({ queryKey: key });
  }
}

/** Trimmed, and empty is no note. */
export const normalizeNotes = (v: unknown): string | null => String(v ?? '').trim() || null;
